import { t } from "i18next";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import FilterableTableLayout from "../../../../components/FilterableTableLayout/FilterableTableLayout";
import { PersistedFilterKeys } from "../../../../modules/filters/filters.types";
import {
  getMfinExciseLicenceRequestFilterItems,
  getMfinExciseLicenceRequestTableColumns,
  MFIN_EXCISE_LICENCE_INITIAL_FILTERS,
} from "../../../../modules/ministry/ministry.constants";
import { MinistryContext } from "../../../../modules/ministry/ministry.context";
import { useMfinExciseLicenceRequestList } from "../../../../modules/ministry/ministry.queries";
import {
  MfinExciseLicenceRequest,
  MfinExciseLicenceRequestListPayload,
  MfinExciseLicenceRequestListResponse,
} from "../../../../modules/ministry/ministry.types";

export const MinistryLicencesList = () => {
  const navigate = useNavigate();
  const { setMinistry } = useContext(MinistryContext);

  const onTableRowClickHandler = (record: MfinExciseLicenceRequest) => {
    const recordId = record.id || record.dozvolaId;
    setMinistry({ selectedLicenceId: recordId });
    navigate(
      `/mfin/listaDozvola/zahtev?id=${recordId}&tipZahteva=${record.tipZahteva}`
    );
  };

  return (
    <FilterableTableLayout<
      MfinExciseLicenceRequest,
      MfinExciseLicenceRequestListResponse,
      MfinExciseLicenceRequestListPayload
    >
      tableRowKey="dozvolaId"
      dataListKey="exciseLicenceRequestList"
      tableName="mfin_excise_licence_request_table"
      toolbarId="mfin_excise_licence_request_list"
      title={t("AKCIZNE_DOZVOLE.LISTA_ZAHTEVA_ZA_AKCIZNE_DOZVOLE")}
      onTableRowClick={onTableRowClickHandler}
      queryHook={useMfinExciseLicenceRequestList}
      getTableColumns={getMfinExciseLicenceRequestTableColumns}
      filterProps={{
        getFilterItems: getMfinExciseLicenceRequestFilterItems,
        initialFilters: MFIN_EXCISE_LICENCE_INITIAL_FILTERS,
        persistedFilterKey:
          PersistedFilterKeys.MFIN_EXCISE_LICENCE_REQUEST_LIST,
      }}
    />
  );
};
